export {
  useInstitutionSubdomain,
  getInstitutionSubdomain,
} from './useInstitutionSubdomain';
